import type { LocalesType } from "~/enums/localization.enums";

export default function useLocalization () {
  const switchLocalePath = useSwitchLocalePath();
  // const { setLocale } = useI18n();

  const setPreferredCourseLanguageCode = (code: LocalesType) => {
    localStorage.setItem('preferredCourseLanguageCode', code);
  };

  const onLocaleChange = async (code: LocalesType) => {
    setPreferredCourseLanguageCode(code);
    window.location.href = switchLocalePath(code as LocalesType);
    // await setLocale(code);
  };

  return {
    onLocaleChange,
    setPreferredCourseLanguageCode,
  };
}